import { Sparkles } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function CommunityCTA() {
  return (
    <section id="community" data-testid="community-cta-section" className="relative px-5 py-20 sm:px-8 sm:py-28">
      <Reveal className="relative mx-auto max-w-5xl overflow-hidden rounded-[2rem] border border-cyan-300/20 bg-gradient-to-br from-violet-950/50 via-[#0a0814] to-teal-950/40 px-6 py-16 text-center sm:px-12 sm:py-24">
        <div className="nebula nebula-a !opacity-60" aria-hidden="true" />
        <div
          aria-hidden="true"
          className="portal-pulse pointer-events-none absolute left-1/2 top-0 h-[60vmin] w-[60vmin] -translate-x-1/2 -translate-y-1/2 rounded-full bg-violet-600/15 blur-[100px]"
        />
        <div className="relative z-10">
          <p className="eyebrow mb-6" data-testid="community-eyebrow">The Door Is Open</p>
          <h2
            data-testid="community-heading"
            className="font-display text-3xl font-bold uppercase leading-tight tracking-[0.12em] text-slate-100 sm:text-4xl lg:text-5xl"
          >
            Are You Ready <span className="text-glow-cyan text-cyan-300">To Shift?</span>
          </h2>
          <p
            data-testid="community-body"
            className="mx-auto mt-7 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base"
          >
            You don't have to figure everything out at once. Sometimes the first step is simply
            being willing to look within.
          </p>
          <div className="mt-11 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <a
              data-testid="community-enter-shift-btn"
              href="https://sourcenuniverse.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-portal"
            >
              Enter The Shift
              <Sparkles className="h-4 w-4" strokeWidth={2} />
            </a>
            <a
              data-testid="community-join-btn"
              href="https://discord.gg/uvMNCcCYkx"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ghost"
            >
              Join The Community
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
